import { render, staticRenderFns } from "./NumberSpinner.vue?vue&type=template&id=4bf5d3cc&scoped=true&"
import script from "./NumberSpinner.vue?vue&type=script&lang=js&"
export * from "./NumberSpinner.vue?vue&type=script&lang=js&"
import style0 from "./NumberSpinner.vue?vue&type=style&index=0&id=4bf5d3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5d3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
